import { render, staticRenderFns } from "./OffercardTeaser.vue?vue&type=template&id=732faf8b&"
import script from "./OffercardTeaser.vue?vue&type=script&lang=js&"
export * from "./OffercardTeaser.vue?vue&type=script&lang=js&"
import style0 from "./OffercardTeaser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports